import styled from "styled-components";
import ReactFullpage from "@fullpage/react-fullpage";
import { ServiceJ1SHeroSection } from "./ServiceJ1SHeroSection";
import { ServiceJ1SBackground } from "./ServiceJ1SBackground";
import { ServiceJ1SKeyBenefit } from "./ServiceJ1SKeyBenefit";
import { ServiceJ1SEachProvisionInLuxury, ServiceJ1SIntroduction } from "./ServiceJ1SEachProvisionInLuxury";
import { ServiceJ1SGetInTouchUs } from "./ServiceJ1SGetInTouchUs";
import { MainFooter } from "../../Footer/MainFooter";
import { useRef, useState, useEffect } from "react";
import { RAButtonBackToTop } from "@/components/customs";
import { useHeaderSolid } from "@/hooks/HeaderSolidContext";

const FULL_PAGE_API_KEY = process.env.NEXT_PUBLIC_FULL_PAGE_API_KEY;

export function ServiceJ1SSnap({ pageContent = {} }) {
	const { content = {} } = pageContent;
	const servicesRef = useRef(null);
	const [activeSlide, setActiveSlide] = useState(0);
	const { headerSolid } = useHeaderSolid();

	useEffect(() => {
		return () => {
			fullpage_api.silentMoveTo(1);
		};
	}, []);

	const onLeave = (origin, destination, direction) => {
		setActiveSlide(destination.index);
		headerSolid(destination.index);
		// arguments are mapped in order of fullpage.js callback arguments do something
		// with the event
		if (direction === "up" && destination.index === 1) {
			setTimeout(function () {
				fullpage_api.moveTo(1);
				fullpage_api.moveSectionDown();
			});
		}
	};

	const onClickContactUs = () => {
		fullpage_api.moveTo(7);
	};
	return (
		<HomepageContainer>
			<div
				ref={servicesRef}
				id="fixed-introduction"
				style={{
					position: "absolute",
					top: "80px",
					opacity: activeSlide >= 2 && activeSlide <= 4 ? 1 : 0,
					transition: "all 0.6s linear",
					zIndex: 100,
					background: "#fff",
					height: "16vh",
					display: "flex",
					alignItems: "flex-end",
				}}
			>
				<ServiceJ1SIntroduction a_provision_in_luxury={content?.a_provision_in_luxury} />
			</div>
			<ReactFullpage
				licenseKey={FULL_PAGE_API_KEY}
				onLeave={onLeave}
				bigSectionsDestination={"top"}
				scrollingSpeed={1100}
				fadingEffect={true}
				normalScrollElements=".ant-picker-panel-container, .ant-modal, #snap-disabled, .ant-picker-time-panel-column, .mapboxgl-canvas, .ant-modal-wrap, .ra-search-airport-ant-select-dropdown"
				credits={{ enabled: false }}
				lazyLoading={false}
				render={({ state, fullpageApi }) => {
					return (
						<ReactFullpage.Wrapper>
							<div className="section" id="jet-one-suite-hero-section">
								<ServiceJ1SHeroSection banner={content?.banner} onClickContactUs={onClickContactUs} />
							</div>
							<EachSlide className="section fp-auto-height" id="jet-one-suite-intro">
								<BodyLargeContainer>
									<ServiceJ1SBackground what_is_jet_1_suites={content?.what_is_jet_1_suites} />
								</BodyLargeContainer>
							</EachSlide>
							<EachSlide
								className="section"
								id="jet-one-suite-a-provision-luxury-1"
								style={{ justifyContent: "flex-center" }}
							>
								<BodyLargeContainer
									style={{
										transition: "all 0.6s linear",
										paddingTop: servicesRef?.current?.clientHeight || "50px",
									}}
								>
									<ServiceJ1SEachProvisionInLuxury
										a_provision_in_luxury={content?.a_provision_in_luxury}
										step="FIRST"
									/>
								</BodyLargeContainer>
							</EachSlide>
							<EachSlide
								className="section"
								id="jet-one-suite-a-provision-luxury-2"
								style={{ justifyContent: "flex-center" }}
							>
								<BodyLargeContainer
									style={{
										transition: "all 0.6s linear",
										paddingTop: servicesRef?.current?.clientHeight || "50px",
									}}
								>
									<ServiceJ1SEachProvisionInLuxury
										a_provision_in_luxury={content?.a_provision_in_luxury}
										step="SECOND"
									/>
								</BodyLargeContainer>
							</EachSlide>
							<EachSlide
								className="section"
								id="jet-one-suite-a-provision-luxury-3"
								style={{ justifyContent: "flex-center" }}
							>
								<BodyLargeContainer
									style={{
										transition: "all 0.6s linear",
										paddingTop: servicesRef?.current?.clientHeight || "50px",
									}}
								>
									<ServiceJ1SEachProvisionInLuxury
										a_provision_in_luxury={content?.a_provision_in_luxury}
										step="THIRD"
									/>
								</BodyLargeContainer>
							</EachSlide>
							<EachSlide className="section fp-auto-height" id="jet-one-suite-key-benefit">
								<ServiceJ1SKeyBenefit key_benefits={content?.key_benefits} />
							</EachSlide>
							<EachSlide className="section fp-auto-height" id="jet-one-suite-get-in-touch">
								<BodyMediumContainer className="ra-j1s-get-in-touch" style={{ width: "100vw" }}>
									<ServiceJ1SGetInTouchUs get_in_touch_with_us={content?.get_in_touch_with_us} />
								</BodyMediumContainer>
							</EachSlide>
							<EachSlide className="section fp-auto-height" id="footer-section">
								<footer
									style={{
										width: "100%",
										scrollSnapAlign: "end",
									}}
								>
									<MainFooter />
									<RAButtonBackToTop onClick={() => fullpage_api.moveTo(1)} />
								</footer>
							</EachSlide>
						</ReactFullpage.Wrapper>
					);
				}}
			/>
		</HomepageContainer>
	);
}

const HomepageContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;
const EachSlide = styled.div`
	width: 100vw;
	transition: all 0.6s linear;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;
const BodyMediumContainer = styled.div`
	max-width: 1442px;
	padding: 84px;
	width: 100%;
	@media (max-width: 991px) {
		padding: 44px;
	}
	@media (max-width: 767px) {
		padding: 30px 32px;
	}
	@media (max-width: 575px) {
		padding: 20px;
	}
`;

const BodyLargeContainer = styled.div`
	max-width: 1442px;
	padding: 84px 136px;
	width: 100%;
	@media (max-width: 991px) {
		padding: 40px 80px;
	}
	@media (max-width: 767px) {
		padding: 30px 32px;
	}
	@media (max-width: 575px) {
		padding: 20px;
	}
`;
